import unknownError from '../../assets/lottie/unknownError.json';
import { AnimatedScreen } from '../AnimatedScreen/AnimatedScreen';

import { useTranslation } from 'react-i18next';

export function GenericErrorScreen() {
  const { t } = useTranslation();
  return (
    <AnimatedScreen
      dataTest='generic-error-screen'
      title={t('error_screen.generic_error.title')}
      imgSrc={unknownError}
      shouldShowImgFirst={false}
    >
      {t('error_screen.generic_error.message')}
    </AnimatedScreen>
  );
}
